import { LockSession } from "@/framework/types/LockSession";
import { LocationInfo } from "@/modules/staff/objects/roomConversation";

export default {
  stateOfChatsWithStaff(state: any): string {
    return state.stateOfChatsWithStaff;
  },
  displayPromptCompleteService(state: any): boolean {
    return state.displayPromptCompleteService;
  },
  checkin(state: any): any {
    return state.checkin;
  },
  adminChanged(state: any): boolean {
    return state.adminChanged;
  },
  adminSubChanged(state: any): boolean {
    return state.adminSubChanged;
  },
  currentGroupId(state: any): number {
    return state.currentGroupId;
  },
  botDictUpdatedIdx(state: any): number {
    return state.botDictUpdatedIdx;
  },
  menuPath(state: any): any {
    return state.menuPath;
  },
  guestInputData(state: any): any {
    return state.guestInputData;
  },
  facility(state: any): any {
    return state.facility;
  },
  selectedMenu(state: any): any {
    if (
      Object.prototype.hasOwnProperty.call(state.selectedMenu, "MainMenuId") ||
      Object.prototype.hasOwnProperty.call(state.selectedMenu, "SubMenu")
    ) {
      return state.selectedMenu;
    } else {
      // Get selectedMenu form LocalStorage
      const selectedMenuString = localStorage.getItem("selectedMenu");
      if (selectedMenuString) {
        return JSON.parse(selectedMenuString);
      }
    }
  },
  previousMenu(state: any): any {
    return state.previousMenu;
  },
  tripadvisorDomain(state: any): any {
    return state.tripadvisorDomain;
  },
  openHotelMenu(state: any): any {
    return state.openHotelMenu;
  },
  getCoupons(state: any): any {
    return state.coupons;
  },
  getCouponById: (state: any) => (id: number) => {
    return state.coupons.find((coupon: any) => coupon.id === id);
  },
  lockSession(state: any): LockSession {
    return state.lockSession;
  },
  tenantId(state: any): number {
    return state.tenantId;
  },
  tenantLangCd(state: any): string {
    return state.tenantLangCd;
  },
  adminTenantFlg(state: any): boolean {
    return state.adminTenantFlg;
  },
  inputRoomNoBeforeConversation(state: any): boolean {
    return state.inputRoomNoBeforeConversation;
  },
  tenantInfo(state: any): any {
    return state.tenantInfo;
  },
  storeLocationInfo(state: any): LocationInfo {
    return state.storeLocationInfo;
  },
  cmsCouponOption(state: any): any {
    return state.cmsCouponOption;
  },
  stopCheckingImportProcess(state: any): any {
    return state.stopCheckingImportProcess;
  },
  getIconColor(state: any): string {
    return state.iconColor;
  },
};
